module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f0c50733c9b6b3e548afc6914a0c7200.png";